import { render, staticRenderFns } from "./WPBaseButton.vue?vue&type=template&id=3fa52cb2"
import script from "./WPBaseButton.vue?vue&type=script&lang=ts"
export * from "./WPBaseButton.vue?vue&type=script&lang=ts"
import style0 from "./WPBaseButton.vue?vue&type=style&index=0&id=3fa52cb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports